export function getSumOfProperty<T>(array: Array<T>, prop: keyof T) {
  return array.reduce((a, b) => {
    return a + ((b[prop] as unknown) as number);
  }, 0);
}
